export enum MedicalFieldEnum {
    OPHTHALMOLOGY = 'OPHTHALMOLOGY'
}
